export const REBELPAY_API_BASE_URL = process.env['REACT_APP_REBELPAY_API_BASE_URL'];
export const REBELPAY_API_KEY_PUBLIC = process.env['REACT_APP_REBELPAY_API_KEY_PUBLIC'];

export const TOKEN_EXPIRATION_BUFFER = 15 * 1000;
export const TOKEN_CREATION_KEY_ACH = 'bank_account_ach';
export const TOKEN_CREATION_KEY_EFT = 'bank_account_eft'; // NOT SUPPORTED YET.
export const TOKEN_CREATION_KEY_CARD = 'card';
export const TOKEN_CREATION_KEY_PLAID = 'plaid_token';
